module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.decryptedValue) ? _c('span', [_vm._v("\n    " + _vm._s(_vm.decryptedValue) + "\n\n    "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Forgot master password and hide data",
      "placement": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.turnOff($event)
      }
    }
  }, [_c('span', {
    staticClass: "b-pf-icon b-pf-icon--encrypted"
  })])])], 1) : _c('span', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.promptMasterPassword($event)
      }
    }
  }, [_c('span', {
    staticClass: "b-pf-icon b-pf-icon--encrypted"
  }), _vm._v(" "), (_vm.label) ? _c('span', [_vm._v(_vm._s(_vm.label))]) : _c('span', [_vm._v("encrypted")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4684dc92"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/cryptValue.vue
// module id = 355
// module chunks = 4